<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent relative">
    
    @if (fireworksVisible()) {
    <div class="congrats-fireworks-overlay" aria-hidden="true">
        <div class="pyro">
            <div class="before"></div>
            <div class="after"></div>
        </div>
    </div>
    }

    <div
        class="my-6 p-4 mx-auto h-16 w-16 rounded-full bg-linear-to-br from-primary to-brand-agency-dark text-white flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-10">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    </div>

    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        You're ready to go
        <span class="bg-linear-to-r from-brand-agency to-brand-studio bg-clip-text text-transparent">viral!</span> 🚀
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">Your
        content brief is live! Invited creators have been notified.</p>



    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">


        <div
            class="divide-y divide-border overflow-hidden rounded-lg border border-border bg-card shadow-sm">
            <div class="px-4 py-5 sm:px-6">
                <div class="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap">

                    <div class="flex min-w-0 items-center">
                        <div class="shrink-0">
                            <div
                                class="flex size-12 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-700 ring-1 ring-emerald-600/20 ring-inset dark:bg-emerald-500/15 dark:text-emerald-400 dark:ring-emerald-400/30">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-8" aria-hidden="true">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4 min-w-0">
                            <h3 class="text-base font-semibold text-emerald-700 dark:text-emerald-400">Content Brief Live!</h3>
                            <p class="truncate text-sm text-secondary">
                                {{ slickOnboardService.newlyCreatedBrief()?.title }}
                            </p>
                        </div>
                    </div>

                    <div class="flex shrink-0">
                        <div
                            class="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground ring-1 ring-border ring-inset">
                            <img [src]="getChannelLogo()" alt="" class="size-8" role="presentation" />
                        </div>

                    </div>
                </div>
            </div>

            @if (collaboratorService.selectedCreators().length > 0) {
            <div class="p-4">
                <div class="w-full grid grid-cols-1 sm:grid-cols-3 items-center justify-between">

                    <article class="flex flex-col items-center justify-center gap-y-2 col-span-1">
                        <h4 class="text-lg sm:text-xl font-semibold text-fuchsia-500">{{
                            collaboratorService.selectedCreators().length }}</h4>
                        <p class="text-sm text-secondary">Invited</p>
                    </article>

                    <article class="flex flex-col items-center justify-center gap-y-2 col-span-1">
                        <h4 class="text-lg sm:text-xl font-semibold text-cyan-500">{{ getPotentialReach() | number }}
                        </h4>
                        <p class="text-sm text-secondary">Potential Reach</p>
                    </article>

                    <article class="flex flex-col items-center justify-center gap-y-2 col-span-1">
                        <h4 class="text-lg sm:text-xl font-semibold text-pink-500">{{ getAverageEngagement() | number }}
                        </h4>
                        <p class="text-sm text-secondary">Average Engagement</p>
                    </article>

                </div>
            </div>
            }
        </div>


        <!-- What happens Next -->
        <div class="mt-8 sm:mt-12">
            <h3 class="text-md sm:text-lg font-semibold text-primary mb-2 sm:mb-4">What happens next:</h3>

            <div class="flex flex-col gap-y-6 sm:gap-y-8">
                <!-- Step 1: Creators review your brief -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Creators review your brief</h4>
                        <p class="text-xs sm:text-sm text-secondary">Matched creators get notified and review your
                            campaign details</p>
                    </div>
                </div>

                <!-- Step 2: Interested creators apply -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                            <line x1="16" y1="13" x2="8" y2="13" />
                            <line x1="16" y1="17" x2="8" y2="17" />
                            <polyline points="10 9 9 9 8 9" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Interested creators apply</h4>
                        <p class="text-xs sm:text-sm text-secondary">Creators who fit your vision submit their
                            applications</p>
                    </div>
                </div>

                <!-- Step 3: You approve your favorites -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">You approve your favorites</h4>
                        <p class="text-xs sm:text-sm text-secondary">Review applications and select the creators you
                            want to work with</p>
                    </div>
                </div>

                <!-- Step 4: Content gets created -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path d="M12 2L2 7l10 5 10-5-10-5z" />
                            <path d="M2 17l10 5 10-5" />
                            <path d="M2 12l10 5 10-5" />
                            <circle cx="12" cy="12" r="1" fill="white" />
                            <circle cx="7" cy="7" r="0.5" fill="white" />
                            <circle cx="17" cy="7" r="0.5" fill="white" />
                            <circle cx="7" cy="17" r="0.5" fill="white" />
                            <circle cx="17" cy="17" r="0.5" fill="white" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Content gets created</h4>
                        <p class="text-xs sm:text-sm text-secondary">Creators produce authentic UGC based on your
                            brief</p>
                    </div>
                </div>

                <!-- Step 5: Track performance in real-time -->
                <div class="flex gap-x-4 items-center">
                    <div
                        class="shrink-0 size-10 sm:size-12 rounded-lg bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <line x1="12" y1="20" x2="12" y2="10" />
                            <line x1="18" y1="20" x2="18" y2="4" />
                            <line x1="6" y1="20" x2="6" y2="16" />
                        </svg>
                    </div>
                    <div class="flex-1">
                        <h4 class="text-sm sm:text-base font-semibold text-primary">Track performance in real-time
                        </h4>
                        <p class="text-xs sm:text-sm text-secondary">Monitor views, engagement, and conversions from
                            your dashboard</p>
                    </div>
                </div>
            </div>
            <!-- What happens Next - END -->

            <!-- Feature Indicators -->
            <!-- <div class="mt-8 sm:mt-12 w-full flex flex-row items-center justify-center px-8 py-2">
                <div class=" flex flex-wrap items-center gap-x-6 sm:gap-x-8 gap-y-4 mx-auto">
                    <div class="flex items-center gap-x-2">
                        <div
                            class="shrink-0 size-5 sm:size-6 rounded bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 sm:size-4">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="12 6 12 12 16 14" />
                            </svg>
                        </div>
                        <span class="text-sm sm:text-base text-secondary">14-day free trial</span>
                    </div>

                    <div class="flex items-center gap-x-2">
                        <div
                            class="shrink-0 size-5 sm:size-6 rounded bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 sm:size-4">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            </svg>
                        </div>
                        <span class="text-sm sm:text-base text-secondary">No credit card required</span>
                    </div>

                    <div class="flex items-center gap-x-2">
                        <div
                            class="shrink-0 size-5 sm:size-6 rounded bg-linear-to-br from-primary to-brand-agency-dark flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 sm:size-4">
                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                            </svg>
                        </div>
                        <span class="text-sm sm:text-base text-secondary">Full access</span>
                    </div>
                </div>
            </div> -->
            <!-- Feature Indicators -->
        </div> 
        


        <div class="w-full flex flex-col gap-y-2 mt-4">

            <div class="w-full flex flex-row items-center justify-center boder-b border-white/10">

                <button type="button" (click)="continueToDashboard()"
                    class="flex-1 sm:w-auto sm:min-w-40 text-center flashy-go-button text-primary flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold min-h-11 touch-manipulation order-1 sm:order-2">

                    <p class="block">Go to Dashboard</p>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 shrink-0">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>

                </button>

            </div>

            <!-- <div class="w-full flex flex-row items-center justify-center gap-x-4">
                <button type="button" routerLink="/manage-brief/{{ slickOnboardService.newlyCreatedBrief()?.id }}/1"
                    class="flex-1 min-h-10 inline-flex items-center justify-center gap-x-1.5 secondary-button-full text-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-ml-0.5 size-5">
                        <rect width="18" height="18" x="3" y="3" rx="2" />
                        <path d="M9 8h7" />
                        <path d="M8 12h6" />
                        <path d="M11 16h5" />
                    </svg>
                    Manage Brief
                </button>
                <button type="button" routerLink="/create-basic-brief"
                    class="flex-1 min-h-10 inline-flex items-center justify-center gap-x-1.5 secondary-button-full text-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-ml-0.5 size-5">
                        <path
                            d="M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="M14 19h6" />
                        <path d="M17 16v6" />
                    </svg>
                    Create Another Brief
                </button>
            </div> -->
        </div>


    </div>
</div>